// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 571 ? "b637e9a5" : chunkId) + "." + {"568":"3d4e286c938a57df","571":"5b21dcdca03f372a","963":"c44a10d81bb49232"}[chunkId] + ".js";
};